import { FormattedMessage } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';

interface SubtotalProps {
  amount?: string;
  displayIcon?: boolean;
  onToggle?: () => void;
}

export const Subtotal = ({
  amount,
  displayIcon = true,
  onToggle,
}: SubtotalProps) => (
  <table className="Subtotal section">
    <tbody>
      <tr>
        <td className="label">
          <span className="large">
            <FormattedMessage
              defaultMessage="Total:"
              description="Total label in checkout summary"
            />
          </span>
        </td>
        <td className="value">
          <span className="large" data-testid="total-amount">
            {roundPrice(amount)}
          </span>
          {displayIcon && (
            <button
              data-testid="summary-price-breakdown-arrow"
              type="button"
              className="CheckoutSummary-PriceBreakDown"
              aria-label="Expands pricing summary"
              onClick={onToggle}
            >
              <span
                className="af-angle-down-2 brand-color"
                data-testid="down-arrow"
              />
            </button>
          )}
        </td>
      </tr>
    </tbody>
  </table>
);
